import { Controller } from 'stimulus'

export default class extends Controller {
  static targets = ['additionalListItem', 'toggleButton'];

  expanded = false;

  toggleAllPills() {
    this.expanded = !this.expanded
    for (const item of this.additionalListItemTargets) {
      this.expanded ? item.removeAttribute('hidden') : item.setAttribute('hidden', '')
    }
  }
}
